import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import Side from "./Side";
import validationResetPassword from "../../../validtions/forms/auth/reset-password";
import httpService from "../../../services/httpServices/httpServices";
import helperSpinner from "../../../helpers/spinner";

function ResetPassword() {
  const [message, setMessage] = useState();
  const params = useParams();
  let messageTag;

  if (message) {
    messageTag = (
      <div dir="rtl" className="col-12 col-md-12 col-sm-12 col-lg-12 col-xl-12">
        <div className={`${message.type_class}`}>
          <i className={`${message.class_icon} pl-2`}></i>
          <span>{message.text}</span>
        </div>
      </div>
    );
  }

  const sendForm = async (e) => {
    e.preventDefault();

    const data = getDataForm();
    if (data == false) {
      return;
    }
    const result = await sendRequest(data);
    if (result == false) {
      return;
    }

    setMessage({
      type_class: "alert alert-success m-0",
      text: result,
      class_icon: "fa fa-exclamation-triangle",
    });
  };

  const sendRequest = async (data) => {
    let result;
    helperSpinner.showSpinner(helperSpinner.CONTAINER_AUTH_PAGE);
    try {
      result = await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/auth/reset-password",
        data
      );
    } catch (error) {
      setMessage({
        type_class: "alert alert-danger m-0",
        text: error.response.data.message,
        class_icon: "fa fa-exclamation-triangle",
      });
      helperSpinner.removeSpinner(helperSpinner.CONTAINER_AUTH_PAGE);
      return false;
    }
    helperSpinner.removeSpinner(helperSpinner.CONTAINER_AUTH_PAGE);
    return result.data.message;
  };

  const getDataForm = () => {
    const password = document.querySelector("#password").value;
    const repeatPassword = document.querySelector("#repeat-password").value;

    if (password !== repeatPassword) {
      setMessage({
        type_class: "alert alert-danger m-0",
        text: "کلمه عبور و تکرار کلمه عبور هم خوانی ندارد.",
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    const searchParams = new URLSearchParams(window.location.search);
    const token = searchParams.get("token");
    const dataInputs = {
      password: password,
      token: token,
    };
    if (validationResetPassword(dataInputs) != true) {
      setMessage({
        type_class: "alert alert-danger m-0",
        text: validationResetPassword(dataInputs),
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }
    return dataInputs;
  };

  return (
    <div
      className="ltr container-fluid container-auth-page "
      id="container-auth-page"
    >
      <div className="row h-100">
        <Side />
        <div
          className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 h-lg-100 py-5 p-lg-0"
          id="container-auth-page-box"
        >
          <div className="d-flex flex-column align-items-center justify-content-center h-100">
            <div id="auth-page-box">
              <div className="border-radius-auth-page">
                <div className="header-box border-radius-auth-page py-1 px-3">
                  وارد کردن کلمه عبور جدید
                </div>
                <div className="body-box d-flex flex-column pt-5 pb-2 px-3">
                  <div className="forget-password-box pt-2 border-hilite-2 border-radius-auth-page">
                    <form onSubmit={sendForm}>
                      {messageTag}
                      <div>
                        <div className="d-flex justify-content-center">
                          <input
                            tabIndex="1"
                            dir="rtl"
                            id="password"
                            type="password"
                            placeholder="کلمه عبور"
                            required
                            className="form-control form-control-hilite w-auto "
                          />
                        </div>
                        <div className="d-flex justify-content-center pt-3">
                          <input
                            tabIndex="1"
                            dir="rtl"
                            id="repeat-password"
                            type="password"
                            required
                            placeholder="تکرار کلمه عبور"
                            className="form-control form-control-hilite w-auto "
                          />
                        </div>

                        <div className="text-center px-3 py-4">
                          <button
                            type="submit"
                            className="btn btn-hilite-1 w-100 border-radius-auth-page"
                          >
                            درج کلمه عبور
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div className="py-1">
                    <span className="pl-2">بازگشت به صفحه</span>
                    <span>
                      <Link to="/login" className="text-link-hilite">
                        ورود
                      </Link>
                    </span>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-between pt-1">
                <span>info@hilite.ir</span>
                <span>۰۲۱-۶۶۷۵۷۳۷۹</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
